export default class Loader {
	constructor(container) {
		this.container = container;
	}

	setLoader() {
		this.unsetLoader();

		const loader = document.createElement('div');
		loader.classList.add('loader');

		this.container.appendChild(loader);
	}

	unsetLoader() {
		this.container.innerHTML = '';
	}
}
